import { render } from "./BloodGlucoseHistory.vue?vue&type=template&id=40040dc4&scoped=true"
import script from "./BloodGlucoseHistory.vue?vue&type=script&lang=js"
export * from "./BloodGlucoseHistory.vue?vue&type=script&lang=js"

import "./BloodGlucoseHistory.vue?vue&type=style&index=0&id=40040dc4&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40040dc4"]])

export default __exports__